import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { PointHistoryRow } from '@models/point';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    pointHistory: PointHistoryRow;
}

function PointLogRow({ pointHistory }:Props) {
    const { t } = useTranslation('point');
    const {
        amount, status, shopName, createdAt,
    } = pointHistory;

    const getStatusKey = (s: string) => `status.${s}`;

    return (
        <Column fullWidth spacing={4}>
            <Text size='lg' color={colors.white} fontWeight='medium'>
                {t(getStatusKey(status))} {shopName}
            </Text>
            <Text color={colors.white}>
                {dayjs(createdAt).format('YYYY.MM.DD.')}
            </Text>
            <TypeRow fullWidth
                spacing={20}
                justify='flex-end'>
                <Text size='xl' color={colors.white}>
                    {status === 'EARNED' ? '+' : '-'}
                </Text>
                <Text size='xl' color={colors.white} fontWeight='bold'>
                    {amount}{t('card.pointUnit')}
                </Text>
            </TypeRow>
        </Column>
    );
}

const TypeRow = styled(Row)`
    margin-top: -6px;
`;

export default PointLogRow;
